/*
 * @Author: liuxiuting
 * @Date: 2023-08-15 14:21:12
 * @LastEditors: liuxiuting
 * @LastEditTime: 2026-03-27 11:12:10
 * @FilePath: \carrier\packages\common-mediax\src\apis\MediaCloudRemoteRepository\Converge.js
 * @Description: 
 * 
 * Copyright (c) 2026 by 用户/公司名, All Rights Reserved. 
 */
import { createAPI } from '@common'
export default {
  // 根据docLibID获取其根文件夹ID
  getRootIdByDocLibID: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0gpmefst0sppu', 'GET', config),
  // 获取树,权限
  getFoldersAdmin: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0dpowfshfe0usff0benjo', 'GET', config),
  // 需要调用获取根文件夹ID获取文件夹节点
  getFoldersTree: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0dpowfshfe0usff', 'GET', config),
    // 需要调用获取根文件夹ID获取文件夹节点
  getFoldersTreeAsset: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0bttfu0usff', 'GET', config),
  // 列表查询
  postConvergedList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0dpowfshfe0mjtu', 'POST', config),
  // 操作
  getActions: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0f60bdujpot', 'GET', config),
  // 选用热文
  getHotSelect: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0dpowfshfe0ipu0tfmfdu', 'GET', config),
  // 每日热文
  getHotDaily: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0dpowfshfe0ipu0ebjmz', 'GET', config),
  // 详情
  getDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0dpowfshfe0efubjm', 'GET', config),
  // 移除
  postDelete: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0dpowfshfe0efmfuf', 'POST', config),
  // 撤稿
  postRevoke: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0dpowfshfe0sfwplf', 'POST', config),
  // 选用
  postSelect: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0dpowfshfe0tfmfdu', 'POST', config),
  // 云媒资选用
  postSelectAsset: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0bttfu0tfmfdu', 'POST', config),
  // 已选用列表
  getSelectList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0dpowfshfe0tfmfdu0mjtu', 'GET', config),
  // 移动
  postMove: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0dpowfshfe0npwf', 'POST', config),
  // 移动的预处理
  getMovePrecheck: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0dpowfshfe0npwf0qsfdifdl', 'GET', config),
  // 转指令的预处理
  getCommandPrecheck: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0dpowfshfe0dpowfsu3Dpnnboe0qsfdifdl', 'GET', config),
  // 资产列表
  postAssetList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0bttfu0mjtu', 'POST', config),
  // 根据 ID 获取资产
  getAssetByID: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0bttfu0hfuCzJE', 'GET', config),
  // 删除资产
  postAssetDelete: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0bttfu0efmfuf', 'POST', config),
  // 删除资产批量
  postAssetDeleteBatch: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0bttfu0efmfufCbudi', 'POST', config),
  // 权限校验
  postSpecialTopicCheck: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0tqfdjbmUpqjd0difdl', 'POST', config),
  // 专题列表
  postSpecialTopicList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0tqfdjbmUpqjdBsujdmf0mjtu', 'GET', config),
  // 权限云媒资、专题可浏览校验
  getCheckItemID: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0tqfdjbmUpqjd0difdlJufnJE', 'GET', config),
  // 添加关注
  postBatchAdd: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0nzBuu0cbudiBee', 'POST', config),
  // 取消关注
  postBatchRemove: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0nzBuu0cbudiEfmfuf', 'POST', config),
  // 获取我的关注列表
  getMyAttList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0nzBuu0mjtu', 'GET', config),
  // 我的关注排序（上移/下移后提交整表顺序）
  postMyAttMove: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0nzBuu0npwf', 'POST', config)


}
